export default [
    {
        "error_id": "T-MANN-01",
        "data": [
            {
                "cross_section": "10535",
                "chn_indexes": [
                    5,
                    6
                ],
                "footnote": null,
                "mann_table": [
                    [
                        3876.6,
                        0.09,
                        0
                    ],
                    [
                        3916.4,
                        0.13,
                        0
                    ],
                    [
                        4095.5,
                        0.09,
                        0
                    ],
                    [
                        4157,
                        0.08,
                        0
                    ],
                    [
                        4943.5,
                        0.03,
                        0
                    ],
                    [
                        4959.71,
                        0.04,
                        0
                    ],
                    [
                        5008.97,
                        0.035,
                        0
                    ],
                    [
                        5022.79,
                        0.12,
                        0
                    ],
                    [
                        5380,
                        0.08,
                        0
                    ],
                    [
                        5524.5,
                        0.1,
                        0
                    ],
                    [
                        5632.8,
                        0.08,
                        0
                    ],
                    [
                        5895.3,
                        0.02,
                        0
                    ]
                ],
                "err_overbank_indexes": [
                    4,
                    11
                ]
            }
        ]
    },
    {
        "error_id": "T-MANN-02",
        "data": [
            {
                "cross_section": "10535",
                "chn_indexes": [
                    5,
                    6
                ],
                "footnote": null,
                "mann_table": [
                    [
                        3876.6,
                        0.09,
                        0
                    ],
                    [
                        3916.4,
                        0.13,
                        0
                    ],
                    [
                        4095.5,
                        0.09,
                        0
                    ],
                    [
                        4157,
                        0.08,
                        0
                    ],
                    [
                        4943.5,
                        0.03,
                        0
                    ],
                    [
                        4959.71,
                        0.04,
                        0
                    ],
                    [
                        5008.97,
                        0.035,
                        0
                    ],
                    [
                        5022.79,
                        0.12,
                        0
                    ],
                    [
                        5380,
                        0.08,
                        0
                    ],
                    [
                        5524.5,
                        0.1,
                        0
                    ],
                    [
                        5632.8,
                        0.08,
                        0
                    ],
                    [
                        5895.3,
                        0.02,
                        0
                    ]
                ],
                "chn_error_indexes": [],
                "err_overbank_indexes": [
                    11
                ]
            }
        ]
    }
]